import axios from "../../plugins/axios-common";

export default {
	actions: {
		async fetchGuaranteeOrder({commit} , payload) {
			const body = { order_id: payload.order_id }
			const settings = {
				method: 'POST',
				data: body,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axios("/api/cash/order/fetchorder", settings).then((res) => {
				if (res) {
					const order = res.data
					commit('updateGuaranteeOrder', order)
					commit('setGuaranteeOrderLoaded', true)
				}
			})
		},
		async createGuaranteeOrder({commit} , payload) {
			const body = {
				order_id: payload.order_id,
				shift: payload.shift_id
			}
			const settings = {
				method: 'POST',
				data: body,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axios("/api/cash/order/guarantee", settings).then((res) => {
				if (res) {
					const guarantee = res.data
					commit('updateGuaranteeCreated', guarantee.id)
				}
			})
		},
	},
	mutations: {
		setGuaranteeOrderLoaded(state, value) {
			state.guaranteeOrderLoaded = value
		},
		updateGuaranteeOrder(state, value) {
			state.guaranteeOrder = value
			state.guaranteeOrderError = false
		},
		updateGuaranteeOrderError(state, value) {
			state.guaranteeOrderError = value
		},
		updateGuaranteeCreated(state, value) {
			state.guaranteeCreated = value
		}
	},
	state: {
		guaranteeOrderLoaded: false,
		guaranteeOrder: {},
		guaranteeOrderError: false,
		guaranteeCreated: false
	},
	getters: {
		guaranteeOrder(state) {
			return state.guaranteeOrder
		},
		guaranteeOrderLoaded(state) {
			return state.guaranteeOrderLoaded
		},
		guaranteeOrderError(state) {
			return state.guaranteeOrderError
		},
		guaranteeCreated(state) {
			return state.guaranteeCreated
		}
	}
}
